(function installRelenserRxScrollBridge() {
  if (window.__relenserRxScrollBridgeV1) {
    return;
  }

  window.__relenserRxScrollBridgeV1 = true;
  var pendingRestore = null;
  var pendingLensCardReveal = null;

  function revealExpandedLensCard(root, lensType) {
    var selectedCardSelector =
      lensType === "sunglass"
        ? ".rl-configurator__card--sunglass.is-selected"
        : ".rl-configurator__card--photochromic.is-selected";

    if (root.querySelector(selectedCardSelector)) {
      return;
    }

    var revealToken = {};
    pendingLensCardReveal = revealToken;

    window.requestAnimationFrame(function waitForConfiguratorRender() {
      window.requestAnimationFrame(function alignExpandedLensCard() {
        if (pendingLensCardReveal !== revealToken) {
          return;
        }

        pendingLensCardReveal = null;

        var selectedCard = root.querySelector(selectedCardSelector);

        if (!selectedCard) {
          return;
        }

        var viewportTop = window.visualViewport?.offsetTop || 0;
        var targetTop = viewportTop + 16;
        var headerGroup = document.querySelector("#header-group");

        if (headerGroup) {
          var headerRect = headerGroup.getBoundingClientRect();

          if (headerRect.bottom > viewportTop && headerRect.top <= viewportTop) {
            targetTop = Math.max(targetTop, headerRect.bottom + 12);
          }
        }

        var scrollDelta = selectedCard.getBoundingClientRect().top - targetTop;

        if (Math.abs(scrollDelta) < 1) {
          return;
        }

        window.scrollBy({
          top: scrollDelta,
          behavior: "smooth",
        });
      });
    });
  }

  document.addEventListener(
    "click",
    function preserveExpandedRxMethodPosition(event) {
      var lensTypeTarget = event.target?.closest?.(
        '[data-action="select"][data-field="lensType"]',
      );

      if (
        lensTypeTarget &&
        (lensTypeTarget.dataset.value === "sunglass" ||
          lensTypeTarget.dataset.value === "photochromic") &&
        typeof window.matchMedia === "function" &&
        window.matchMedia("(max-width: 860px)").matches
      ) {
        var configuratorRoot = lensTypeTarget.closest(
          "[data-relenser-configurator]",
        );

        if (configuratorRoot) {
          revealExpandedLensCard(
            configuratorRoot,
            lensTypeTarget.dataset.value,
          );
        }

        return;
      }

      if (
        typeof window.matchMedia === "function" &&
        !window.matchMedia("(min-width: 861px)").matches
      ) {
        return;
      }

      var target = event.target?.closest?.(
        '[data-action="select"][data-field="lensDataMethod"]',
      );

      if (!target || target.dataset.value === "upload_or_enter") {
        return;
      }

      var root = target.closest("[data-relenser-configurator]");

      if (
        !root ||
        !root.querySelector(
          ".rl-configurator__card--rx-method.is-selected",
        )
      ) {
        return;
      }

      var anchorTop = target.getBoundingClientRect().top;
      var selectedValue = target.dataset.value;
      var restoreToken = {};
      pendingRestore = restoreToken;

      window.requestAnimationFrame(function waitForConfiguratorRender() {
        window.requestAnimationFrame(function restoreResidualScrollOffset() {
          if (pendingRestore !== restoreToken) {
            return;
          }

          pendingRestore = null;

          var selectedOption = Array.from(
            root.querySelectorAll(
              '[data-action="select"][data-field="lensDataMethod"]',
            ),
          ).find(function (option) {
            return option.dataset.value === selectedValue;
          });

          if (!selectedOption) {
            return;
          }

          var scrollDelta =
            selectedOption.getBoundingClientRect().top - anchorTop;

          // A current app bundle has already restored this position. The
          // bridge only compensates for the residual left by older bundles.
          if (Math.abs(scrollDelta) < 1) {
            return;
          }

          window.scrollBy({
            top: scrollDelta,
            behavior: "auto",
          });
        });
      });
    },
    true,
  );
})();
